import React from "react";
import "./home.css";

import Logo from "../../images/logo.svg";

import { NavLink, useHistory } from "react-router-dom";
import SignUp from "../authentication/SignUp";
import SignIn from "../authentication/SignIn";

function Home({ signUp, signIn, modalsDispatch, authState }) {
  // get props from HomeIndex.jsx

  const history = useHistory();

  // All methods to handle sign up and sign in drawer
  const handleSignUpOpen = () => {
    modalsDispatch({ type: "OPEN_SIGN_UP" });
  };
  const handleSignUpClose = () => {
    modalsDispatch({ type: "CLOSE_SIGN_UP" });
  };
  const handleSignInOpen = () => {
    modalsDispatch({ type: "OPEN_SIGN_IN" });
  };
  const handleSignInClose = () => {
    modalsDispatch({ type: "CLOSE_SIGN_IN" });
  };

  const handleClickedSignIn = () => {
    modalsDispatch({ type: "CLOSE_SIGN_UP" });
    modalsDispatch({ type: "OPEN_SIGN_IN" });
  };

  const handleClickedSignUp = () => {
    modalsDispatch({ type: "CLOSE_SIGN_IN" });
    modalsDispatch({ type: "OPEN_SIGN_UP" });
  };

  const gotToMenu = () => {
    history.push("/food/categories");
  };

  return (
    <>
      <div className="home_container">
        <div className="home_main_div">
          <div className="left_white">
            <div className="header">
              <img src={Logo} alt="logoImg" />
              <div className="header_btn_box">
                {authState.loggedIn ? (
                  <>
                    <button className="auth_btnInActive" onClick={gotToMenu}>
                      Menu
                    </button>
                    <button className="zip_code">
                      {authState.loggedInUser.user.zipCode}
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      className={signIn ? "auth_btnActive" : "auth_btnInActive"}
                      onClick={handleSignInOpen}
                    >
                      Login
                    </button>
                    <button
                      className={signUp ? "auth_btnActive" : "auth_btnInActive"}
                      onClick={handleSignUpOpen}
                    >
                      Sign Up
                    </button>
                  </>
                )}
              </div>
            </div>
            <div className="body">
              <div className="text_div">
                <h4>Unexpected guests?</h4>
                <p>Order food from favourite restaurant near you.</p>
              </div>
              <div className="input_div">
                <form
                  style={{ border: "1px solid #8895A7", borderRight: "none" }}
                >
                  <input
                    className="find_input"
                    type="text"
                    placeholder="Enter a location"
                    name="location"
                  />
                </form>
                <NavLink
                  exact
                  to="/food/categories"
                  style={{ textDecoration: "none" }}
                >
                  <button className="find_btn" type="submit">
                    Find Code
                  </button>
                </NavLink>
              </div>
            </div>
            <div className="footer">
              <h6 className="footer_head">POPULAR CITIES BANGLADESH</h6>
              <div className="names_city">
                <span>Dhaka</span>
                <span>Sylhet</span>
                <span>Khulna</span>
                <span>Chattogram</span>
                <span>Bogura</span>
                <span>Cumilla</span>
              </div>
            </div>
          </div>
          <div className="right_img">
            <img
              className="food_img"
              src="https://images.unsplash.com/photo-1511690656952-34342bb7c2f2?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=700&q=80"
              alt="food-img"
            />
          </div>
        </div>
      </div>
      <div>
        <SignUp
          signUp={signUp}
          handleSignUpClose={handleSignUpClose}
          handleClickedSignIn={handleClickedSignIn}
        />
        <SignIn
          signIn={signIn}
          handleSignInClose={handleSignInClose}
          handleClickedSignUp={handleClickedSignUp}
        />
      </div>
    </>
  );
}

export default Home;
